import { render, staticRenderFns } from "./box6.vue?vue&type=template&id=fe3f85e4&scoped=true&"
import script from "./box6.vue?vue&type=script&lang=js&"
export * from "./box6.vue?vue&type=script&lang=js&"
import style0 from "./box6.vue?vue&type=style&index=0&id=fe3f85e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3f85e4",
  null
  
)

export default component.exports